import type { ApiErrorMessage, WithApiErrorMessage } from './apiErrorMessage';
import { toDiagnosticApiErrorMessage } from './apiErrorMessage';

/**
 * An error holding why the call failed, still unresolved. `message` keeps the diagnostic text
 * for logging; anything user-facing resolves `apiErrorMessage`. `status` is the HTTP status,
 * absent for a failure that never reached the network, such as a geocoder callback.
 */
export default class APIError extends Error implements WithApiErrorMessage {
  status?: number;

  errorType?: string;

  apiErrorMessage: ApiErrorMessage;

  constructor(message: ApiErrorMessage, status?: number, errorType?: string) {
    super(toDiagnosticApiErrorMessage(message));
    this.status = status;
    this.errorType = errorType;
    this.apiErrorMessage = message;
  }
}
